//
//
//
//
//
//
//
//

import json2csv from 'json2csv';
export default {
    props: {
        fields: undefined,
        data: undefined,
        downloadName: {
            default: 'export.csv'
        }
    },
    computed: {
        downloadUrl() {
            return this.data.length > 0 ? "data:text/csv," + encodeURIComponent(json2csv({data: this.data, fields: this.fields})) : 'javascript:void(0);';
        }
    }
}



// WEBPACK FOOTER //
// ./src/CsvDownload.vue